export default __webpack_public_path__ + "static/media/obito.032d495c.png";